import { optionsMap } from 'pro-gallery-lib';
import { WIX_GALLERY_CONSTS } from '../consts';
export function isFullscreenEnabled(options) {
  return [WIX_GALLERY_CONSTS.behaviourParams_item_clickAction.EXPAND, WIX_GALLERY_CONSTS.behaviourParams_item_clickAction.FULLSCREEN].includes(options[optionsMap.behaviourParams.item.clickAction] || '') || false;
}
//# sourceMappingURL=isFullscreen.js.map